export default __webpack_public_path__ + "static/media/pfr2.59c60184.png";